module.exports = __webpack_public_path__ + "static/media/pigeage-pig.8c03ab4f.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./media/videos/pigeage-pig.mp4
 ** module id = 468
 ** module chunks = 0
 **/